import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { AssociatesInjection } from '../containers/associatesInjection';
import { InputCpfCnpj } from '../../../components/input_cpf';
import { cpf } from 'cpf-cnpj-validator';

export const ModalVerifyCpf = ({ isOpen, toggle }) => {
  const { checkCpf } = AssociatesInjection();
  const [value, setValue] = useState('');
  const [invalid, setInvalid] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const verifyCPF = (e) => {
    if (!cpf.isValid(e)) {
      setInvalid(true);
    } else {
      setInvalid(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (cpf.isValid(value)) {
      await checkCpf({ cpf: value, history });
    } else {
      setInvalid(true);
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      size="md"
      centered
    >
      <ModalHeader>
        <p>Novo Associado</p>
      </ModalHeader>
      <ModalBody>
        <Label>Informe o CPF para iniciar o cadastro</Label>
        <InputCpfCnpj
          isCPF
          value={value}
          onChange={(e, type) => {
            if (type === 'CPF') {
              setValue(e.target.value);
              verifyCPF(e.target.value);
            }
          }}
          invalid={invalid}
        />
        {invalid && <p className="labelErrorValidation">CPF inválido</p>}
      </ModalBody>
      <ModalFooter>
        <div className="hstack gap-2 justify-content-end mb-3 me-3">
          <button
            to="#"
            className="btn btn-link"
            onClick={() => {
              toggle();
              setValue('');
              setInvalid(false);
            }}
          >
            Cancelar
          </button>
          <Button
            disabled={loading}
            className="btn btn-primary"
            onClick={() => handleSubmit()}
          >
            Continuar
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};
